<template>
  <div class="static-order-main">
      <div class="static-order-top">
          <el-form ref="form" :model="form" label-position="left" class="demo-form-inline" :inline="true">
              <el-form-item>
                  <el-input v-model="form.searchKey" :placeholder="$t('wallet_usage.order_no_placeholder')"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-col :span="12">
                      <el-form-item prop="startTime">
                          <el-date-picker type="date" :placeholder="$t('wallet_usage.start_time_placeholder')" v-model="form.startTime" style="width: 100%;">
                          </el-date-picker>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item prop="endTime">
                          <el-date-picker type="date" :placeholder="$t('wallet_usage.end_time_placeholder')" v-model="form.endTime" style="width: 100%;"></el-date-picker>
                      </el-form-item>
                  </el-col>
              </el-form-item>
              <el-form-item>
                  <el-button @click="onSearch" v-cloak>{{$t('wallet_usage.search')}}</el-button>
              </el-form-item>
          </el-form>
      </div>
      <div class="static-order-center">
          <div class="list-table">
              <el-table 
                :data="tableData" 
                :cell-class-name="tableCellClassName" 
                style="width: 100%" 
                v-loading="searching"
                height="100%"
              >
                  <el-table-column prop="order_no":label="tableName[0]" header-align="center" align="center" width="160">
                  </el-table-column>
                  <el-table-column prop="package" :label="tableName[1]" header-align="center" align="center">
                  </el-table-column>
                  <el-table-column prop="type" :label="tableName[2]" header-align="center" align="center">
                  </el-table-column>
                  <el-table-column prop="deductedBalance" :label="tableName[3]" header-align="center" align="center">
                  </el-table-column>
                  <el-table-column prop="subscriptionTime" :label="tableName[4]" header-align="center" align="center">
                  </el-table-column>
              </el-table>
              <el-pagination
                  small
                  layout="total, prev, pager, next, sizes"
                  @current-change = "handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="curPage"
                  :page-size="paginationSize"
                  :size="paginationSize"
                  :total="paginationTotal"
                  :page-sizes="$store.state.userPreferences?.paginationSizes || [10, 20, 50, 100]">
              </el-pagination>
              
          </div>
      </div>
  </div>
  </template>
  
  <script>
  import {getBalancePayLogList} from '@/http/api/member'
  import {utcTimestampToLocalTime, localOrderDayBoundary } from '@/util/human'

  export default {
    name: 'recharge-usage',
    components: {
    },
  
    data() {
      return {
          searching: false,
  
          form:{
              searchKey:'',
              startTime:'',
              endTime:'',
          },
          
          tableData:[],
  
          highlight_order_no:'',
          highlightedRows: [],
          
          paginationTotal:0,
          curPage:1,
      }
    },
    inject: ['updateCurrentMenuUrl'],
    computed: {
      tableName(){
        return this.$t("wallet_usage.table_name");
      },
      isLogin() {
        return this.$store.state.isLogin;
      },
      paginationSize() {
        return this.$store.state.userPreferences?.paginationSize || 10;
      }
    },
    watch: {
    },
    created() {
      this.updateCurrentMenuUrl('/ucenter/wallet/usage/');
  
      this.highlight_order_no = this.$route.query?.orderNo ?? ''
    },
    mounted() {
      if (this.isLogin) {
        this.get_order_list(1);
      } else {
        this.gotoLogin();
      }
    },
    methods: {
      
      onSearch:function(){
          this.get_order_list(1)  
      },
      get_order_list:function(page){
          let self = this
          self.searching = true;

          var size = self.paginationSize;
          if (typeof(page) == 'undefined') {
              page = 1;
          }
          self.curPage = page
          let param = {
              page: page, 
              limit: size,
              order_no: self.form.searchKey,
              start_time: self.form.startTime ? localOrderDayBoundary(self.form.startTime) : '',
              // Finance APIs accept seconds and include that second through .999999 server-side.
              end_time: self.form.endTime ? localOrderDayBoundary(self.form.endTime, true).slice(0, 19) : '',
          }
          self.tableData = []
  
          getBalancePayLogList(param).then(res => {
            let obj = res.data
  
            self.paginationTotal = obj.count
  
            let list = obj.list || [];
            for (let i = 0; i < list.length; i++) {
                let currency = list[i].currency === 'CNY' ? '￥' : (!list[i].currency || list[i].currency === 'USD' ? '$' : list[i].currency + ' ');
                list[i].type = list[i]['deducted_amount'] > 0 ? self.$t('wallet_usage.type.deduct') : self.$t('wallet_usage.type.refund');
                // Preserve DECIMAL precision supplied by the API; legacy numbers remain supported.
                list[i].deductedBalance = currency + String(list[i]['deducted_amount']).replace(/^-/, '');
                list[i].subscriptionTime = list[i]['create_time'] == 0 ? '--' : utcTimestampToLocalTime(list[i]['create_time']*1000, 1);
                self.tableData.push(list[i])
            }
            this.$nextTick(() => {
              this.highlightRows();
            });
          }).catch(e => {
            // self.$message.error(e.message ?? e.msg ?? "get recharge logs failed");
          }).finally(() => {
            self.searching = false;
          });
      },
      highlightRows() {
        this.highlightedRows = [this.highlight_order_no];
        this.$forceUpdate();
        setTimeout(() => {
          this.highlightedRows = [];
        }, 2000);
      },
      tableCellClassName:function({row, column, rowIndex, columnIndex}){
        let classNames = [];
        // 如果是 type 列且值为 refund
        if (row.deducted_amount < 0 && column.property === 'type') {
          classNames.push('refund-cell');
        }

        if (this.highlightedRows.includes(row.order_no)) {
          classNames.push('row-highlight-transition');
        }
        if (row.order_no === this.highlight_order_no) {
          classNames.push('row-highlight');
        }
        return classNames.join(' ');
      },
      gotoLogin() {
        location.href='/login/';
      },
      handleCurrentChange:function(){
        if (this.isLogin) {
            this.get_order_list(this.curPage)
        } else {
            gotoLogin();
        }
      },
      handleSizeChange(val) {
        if (this.isLogin) {
          this.$store.commit('updateUserPreference', { paginationSize: val });
          this.get_order_list(1)
        } else {
          gotoLogin();
        }
      },
    
    }
  }
  
  </script>
  
  <style scoped lang="scss">
    ::v-deep .el-loading-mask {
      display: flex;
      justify-content: center;
      align-items: center;
      
      .el-loading-spinner {
        margin: 0;
        width: fit-content;
      }
    }

    ::v-deep .row-highlight-transition {
      background-color: #db2a0f;
      transition: background-color 1s ease-in-out;
    }

    ::v-deep .row-highlight {
      background-color: #e97a05;
      transition: background-color 2s ease-in-out;
    }

    ::v-deep .el-tooltip img {
      display: inline-block;
    }

    .static-order-main {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .static-order-top {
        ::v-deep .demo-form-inline {
          > .el-form-item {
            &:first-of-type {
              width: 100%;
              max-width: 266px;
              height: 56px;
              background-color: #f0f2f9;
              border-radius: 10px;

              .el-form-item__content {
                width: 100% !important;
                height: 100% !important;

                .el-input {
                  width: 100%;
                  height: 100%;

                  .el-input__inner {
                    width: 100%;
                    height: 100%;
                    background-color: #f0f2f9;
                    border-radius: 10px;
                    border: none;
                    outline: none;
                    font-family: "Poppins-Medium";
                    font-size: 16px;
                    color: #11182e;

                    &::-webkit-input-placeholder,
                    &::-moz-input-placeholder,
                    &::-ms-input-placeholder {
                      font-family: "Poppins-Medium";
                      font-size: 16px;
                      color: rgba(204, 204, 204, 0.6);
                    }
                  }
                }
              }
            }

            &:nth-of-type(2) {
              width: 100%;
              max-width: 556px;

              .el-form-item__content {
                width: 100%;

                .el-form-item {
                  width: calc(100% - 12px);

                  .el-input {
                    .el-input__inner {
                      width: 100%;
                      border: none;
                      padding-left: 45px;
                      height: 56px;
                      background-color: #f0f2f9;
                      border-radius: 10px;
                      font-family: "Poppins-Medium";
                      font-size: 16px;
                      color: #11182e;

                      &::-webkit-input-placeholder,
                      &::-moz-input-placeholder,
                      &::-ms-input-placeholder {
                        font-family: "Poppins-Medium";
                        font-size: 16px;
                        color: rgba(204, 204, 204, 0.6);
                      }
                    }

                    .el-input__icon {
                      font-size: 24px;                      
                      font-weight: bold;
                      color: #276dfd;
                      line-height: 56px;
                    }
                  }
                }
              }
            }

            &:nth-of-type(3) {
              width: 100%;
              max-width: 266px;
              height: 56px;
              background-color: #f0f2f9;
              border-radius: 10px;

              .el-form-item__content {
                width: 100%;
                height: 100%;

                .el-select {
                  width: 100%;
                  height: 100%;

                  .el-input {
                    width: 100% !important;
                    height: 100% !important;

                    .el-input__inner {
                      width: 100%;
                      height: 100%;
                      background-color: #f0f2f9;
                      border-radius: 10px;
                      border: none;
                      outline: none;
                      font-family: "Poppins-Medium";
                      font-size: 16px;
                      color: #11182e;

                      &::-webkit-input-placeholder,
                      &::-moz-input-placeholder,
                      &::-ms-input-placeholder {
                        font-family: "Poppins-Medium";
                        font-size: 16px;
                        color: rgba(204, 204, 204, 0.6);
                      }
                    }
                  }
                }
              }
            }

            &:last-of-type {
              width: 100%;
              max-width: 163px;
              height: 56px;

              .el-form-item__content {
                width: 100% !important;
                height: 100% !important;

                .el-button {
                  width: 100%;
                  height: 100%;
                  background-color: #276dfd;
                  border-radius: 10px;
                  font-family: "Poppins-Medium";
                  font-size: 16px;
                  font-weight: normal;
                  font-stretch: normal;
                  letter-spacing: 0px;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }

      .static-order-center {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;

        ::v-deep .list-table {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
          padding-bottom: 60px; // 为分页组件预留空间

          .el-table {
            flex: 1;
            overflow: auto;

            &::before {
              height: 0px;
            }

            .el-table__body-wrapper {
              border-radius: 0px 0px 10px 10px;
            }

            .el-table__header {
              thead {
                width: 100%;
                height: 56px;
                background-color: #dce4fa;
                border-radius: 10px 10px 0px 0px;

                tr {
                  height: 56px;
                  background-color: #dce4fa;

                  th.el-table__cell {
                    height: 56px;
                    background-color: #dce4fa;

                    .cell {
                      font-family: "Poppins-Medium";
                      font-size: 16px;
                      font-weight: normal;
                      font-stretch: normal;
                      letter-spacing: 0px;
                      color: #11182e;
                    }

                    &:first-of-type {
                      border-radius: 10px 0px 0px 0px;
                    }

                    &:nth-of-type(5) {
                      border-radius: 0px 10px 0px 0px;
                    }
                  }
                }
              }
            }

            .el-table__body {
              tbody {
                tr.el-table__row {
                  td.el-table__cell {
                    height: 56px;

                    &.refund-cell .cell {
                      color: #f56c6c;
                    }

                    .cell {
                      font-family: "Poppins-Medium";
                      font-size: 14px;
                      font-weight: normal;
                      font-stretch: normal;
                      letter-spacing: 0px;
                      color: rgba(17, 24, 46, 0.6);

                      .operate {
                        position: relative;
                        display: inline-block;

                        .operate-tips {
                          position: absolute;
                          right: 0;
                          top: 50%;
                          padding: 4px 11px;
                          background-color: rgba(34, 50, 101, 0.1);
                          border-radius: 6px;
                          font-family: "Poppins-Medium";
                          font-size: 14px;
                          font-weight: normal;
                          font-stretch: normal;
                          line-height: 21px;
                          letter-spacing: 0px;
                          color: #223265;
                        }

                        &:first-of-type {
                          margin-right: 17px;
                        }

                        &:last-of-type {
                          margin-left: 17px;
                        }
                      }
                    }
                  }

                  &:nth-child(odd) {
                    background-color: #fcfcfe;
                  }

                  &:nth-child(even) {
                    background-color: #f0f2f9;
                  }
                }
              }
            }
          }

          .el-pagination {
            padding: 10px 0;
            text-align: center;
          }
        }
      }
    }
  </style>
